import css from './frame.module.scss';

import { createContext, useState, useCallback, memo } from 'react';

type TFlashMode = 'bad' | 'neutral' | 'good';
type TFlash = (mode: TFlashMode) => void;

export const flashCtx = createContext<TFlash | null>(null);
flashCtx.displayName = 'FrameFlash';

const FLASH_DELAY = 250; // ms

const Frame: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<TFlashMode | null>(null);
  const flash = useCallback((mode: TFlashMode) => {
    setMode(mode);
    setTimeout(() => setMode(null), FLASH_DELAY);
  }, []);

  return (
    <div className={css.frame} data-flash={mode || undefined}>
      <flashCtx.Provider value={flash}>{children}</flashCtx.Provider>
      <div className={css.frameMobileFlash} />
    </div>
  );
};

export default memo(Frame);
